import { Button, Group, Modal, TextInput } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

type LinkEditorModalProps = {
  opened: boolean;
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  onRemove: () => void;
  onClose: () => void;
  isEditing: boolean;
};

const LinkEditorModal: React.FC<LinkEditorModalProps> = ({
  opened,
  value,
  onChange,
  onSubmit,
  onRemove,
  onClose,
  isEditing,
}) => {
  const inputRef = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    if (opened) {
      requestAnimationFrame(() => {
        inputRef.current?.focus();
        inputRef.current?.select();
      });
    }
  }, [opened]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit();
  };

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(event.currentTarget.value);
    },
    [onChange],
  );

  return (
    <Modal opened={opened} onClose={onClose} title={isEditing ? 'Редактировать ссылку' : 'Добавить ссылку'} size="sm">
      <form onSubmit={handleSubmit}>
        <TextInput
          ref={inputRef}
          label="Адрес"
          placeholder="https://example.com"
          value={value}
          onChange={handleChange}
          data-autofocus
        />
        <Group justify="space-between" mt="md">
          <Button variant="default" onClick={onClose} type="button">
            Отмена
          </Button>
          <Group gap="sm">
            <Button variant="light" color="red" onClick={onRemove} type="button" disabled={!isEditing}>
              Удалить
            </Button>
            <Button type="submit">Сохранить</Button>
          </Group>
        </Group>
      </form>
    </Modal>
  );
};

export default observer(LinkEditorModal);
